import { Button, Link, Loading } from 'components'
import React from 'react'

import { ArrowRightIcon } from '@radix-ui/react-icons'

import { useAllCodingRooms } from '../CodingRoom.services'
import { CodingRoomsGrid, ShowError } from '../components'

const CodingRoomsEntry = () => {
  const { data: codingRooms, isLoading, isError, error } = useAllCodingRooms()

  if (isLoading) {
    return <Loading centerParent />
  }

  if (!codingRooms || isError) {
    return <ShowError error={error} />
  }

  return (
    <div className="mx-auto flex flex-col my-10 gap-y-8 px-2">
      <div className="text-center space-y-3">
        <h2 className="text-3xl font-bold">Explore Coding Rooms</h2>
        <p className="text-lg font-medium text-zinc-300">
          Join or create a room to solve DSA questions with other users.
        </p>
        <div className="flex items-center justify-center">
          <Link
            href="/coding-rooms/create"
            aria-hidden={true}
            className="focus:outline-none">
            <Button className="w-max mr-2">
              Create Room <ArrowRightIcon className="ml-2" />
            </Button>
          </Link>
          <Link
            href="/coding-rooms/join"
            aria-hidden={true}
            className="focus:outline-none">
            <Button className="w-max mr-2">
              Join Room <ArrowRightIcon className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>

      <CodingRoomsGrid rooms={codingRooms} />
    </div>
  )
}

export default CodingRoomsEntry

CodingRoomsEntry.auth = {
  shouldBeLoggedIn: true,
  redirectUrl: '/coding-rooms'
}

CodingRoomsEntry.seo = {
  title: 'Devsnest | Coding Room',
  description:
    'Solve DSA coding problems and compete with your friends and other people'
}
